import React from "react"

export default ({genderCode}) =>{
    switch (genderCode) {
        case "M":
            return <span>Homme</span>
        case "F":
            return <span>Femme</span>
        default:
            return "---"
    }
}